import React from "react";
import PropTypes from "prop-types";

export default class LoadingMask extends React.Component{
    render(){
        if(this.props.isLoading){
            return<div className="lmask"></div>;
        } else {
            return <div></div>;
        }
    }
}

LoadingMask.propTypes = {
    isLoading: PropTypes.bool.isRequired
};
